import React, { useState } from "react";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import HairStyles from "./components/HairStyles";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import Booking from "./components/Booking";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { translations } from "./mock";

function App() {
  const [lang, setLang] = useState('id');
  const t = translations[lang];

  return (
    <div className="App">
      <Header t={t} lang={lang} setLang={setLang} />
      <Hero t={t} />
      <Services t={t} lang={lang} />
      <HairStyles t={t} lang={lang} />
      <Gallery t={t} />
      <Testimonials t={t} lang={lang} />
      <Booking t={t} lang={lang} />
      <Contact t={t} lang={lang} />
      <Footer t={t} lang={lang} />
      <Toaster />
    </div>
  );
}

export default App;
